Object.defineProperty(exports, "__esModule", { value: true });
function animate(progressHandler, options) {
    var isStopped = false;
    var duration = (options && options.duration)
        ? options.duration
        : 300;
    var timingFunction = (options && options.timingFunction)
        ? options.timingFunction
        : TimingFunctions.linear;
    var startTime = window.performance.now();
    var animateProcess = function () {
        var tickTime = window.performance.now();
        if (isStopped) {
            return;
        }
        var timeFraction = Math.min(1, (tickTime - startTime) / duration);
        progressHandler(timingFunction(timeFraction));
        if (timeFraction < 1) {
            window.requestAnimationFrame(animateProcess);
        }
    };
    window.requestAnimationFrame(animateProcess);
    return {
        stop: function () {
            isStopped = true;
        }
    };
}
exports.animate = animate;
var TimingFunctions = /** @class */ (function () {
    function TimingFunctions() {
    }
    TimingFunctions.linear = function (time) {
        return time;
    };
    return TimingFunctions;
}());
exports.TimingFunctions = TimingFunctions;
